import { config } from "tsi-common-react/src/config";
import { strings } from "tsi-common-react/src/localization";

config.update({
    ENABLE_CHECKOUT_CAPTCHA: true,
    ENABLE_EMAIL_SIGNUP_CAPTCHA: true,
});

strings.update({
    // TODO(i18n): This hardcoded English string should be internationalized using t tagged template or jt for HTML content. Consider using jt to preserve HTML structure: jt`Your payment has been declined. Please take the following steps...` with proper variable interpolation for WEBSITE_SUPPORT_NUMBER and ORDER_ID.
    REJECT_MSG_CYBERSOURCE:
        `Your payment has been declined. Please take the following steps to complete your order: <ul>` +
        `<li>Step 1 - Verify that your payment and billing information is accurate, correct any errors and resubmit your order</li>` +
        `<li>Step 2 - If you believe your payment and billing information is correct, please contact your financial institution</li>` +
        `<li>Step 3 - If you are still experiencing issues, you may call us at WEBSITE_SUPPORT_NUMBER and provide reference ` +
        `number ORDER_ID</li></ul>`,

    // TODO(i18n): This hardcoded English string should be internationalized using t tagged template with variable interpolation: t`An error occurred while placing your order. Please verify the information is correct, and resubmit your order. If you are still experiencing issues, you may call us at ${WEBSITE_SUPPORT_NUMBER} and provide reference number ${ORDER_ID}.`
    CHECKOUT_ERROR_FALLBACK:
        `An error occurred while placing your order. Please verify the information is correct, and resubmit your order. ` +
        `If you are still experiencing issues, you may call us at WEBSITE_SUPPORT_NUMBER and provide reference number ORDER_ID.`,
});
